module.exports = __webpack_public_path__ + "static/media/bv.19acce5f.svg";